import { MouseEventHandler } from 'react'

import clsx from 'clsx'

import NoImage from '@/components/view/utils/image/NoImage'

interface Props {
  src: string | undefined
  alt?: string
  width: number | '100%'
  height: number | '100%'
  lazy?: boolean
  fitCover?: boolean
  square?: boolean
  radius?: 0 | 4 | 8
  border?: boolean
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLImageElement>
}

const Image = ({
  src,
  alt,
  width,
  height,
  lazy = false,
  fitCover = false,
  square = false,
  radius = 4,
  border = false,
  disabled = false,
  onClick
}: Props) => {
  const roundedClass = radius == 4 ? 'rounded' : radius == 8 ? 'rounded-lg' : ''
  return (
    <>
      {src ? (
        <img
          src={src}
          alt={alt ? alt : ''}
          loading={lazy ? 'lazy' : 'eager'}
          className={clsx(
            'max-w-none',
            fitCover ? 'object-cover' : 'object-contain',
            square && 'aspect-square',
            border && 'border-primary border',
            disabled && 'opacity-16',
            width == '100%' && 'w-full',
            height == '100%' && 'h-full',
            roundedClass
          )}
          width={width}
          height={height}
          onClick={onClick}
        />
      ) : (
        width != '100%' &&
        height != '100%' && (
          <NoImage width={width as number} height={height as number} border={border} />
        )
      )}
    </>
  )
}

export default Image
